import React, { useState, useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import Select from 'react-select';
import CustomControl from '../CustomControl/CustomControl';
import { infocdn } from '../../services/ApiService';


const NewsShowcaseSettings = ({ change, featuresList }) => {
  const [isManualGeo, setManualGeo] = useState(false);
  const [isManualTheme, setManualTheme] = useState(false);

  const [themesList, setThemesList] = useState([]);
  const [geoList, setgeoList] = useState([]);

  const handleChange = control => {
    if (control === 'geo') {
      setManualGeo(!isManualGeo);

      if (isManualGeo) {
        change(null, '4');
      }
    } else {
      setManualTheme(!isManualTheme);

      if (isManualTheme) {
        change(null, '3');
      }
    }
  };

  useEffect(() => {
    if (featuresList['4']) {
      setManualGeo(true);
    }

    if (featuresList['3']) {
      setManualTheme(true);
    }

    infocdn.getNewsShowcaseGeoList().then(response => {
      if (response && response.items) {
        const { items } = response;

        const list = Object.keys(items).map(elem => ({
          label: elem,
          value: items[elem],
        }));

        setgeoList(list);
      }
    });

    infocdn.getNewsShowcaseThemesList().then(response => {
      if (response && response.items) {
        const { items } = response;

        const list = items.map(elem => ({
          value: elem.id,
          label: elem.title,
        }));

        setThemesList(list);
      }
    });
  }, []);

  return (
    <ul className="feature-list news-showcase-settings-inner">
      <li>
        <CustomControl
          key={`manual_geo_control`}
          id={`manual_geo_control`}
          name={`manual_geo_control`}
          checked={isManualGeo}
          value={1}
          onChange={handleChange.bind(null, 'geo')}
          type="checkbox"
          className="custom-control-xs"
        >
          <FormattedMessage
            id={'flow.features.news_showcase.settings.geo.label'}
            defaultMessage={'News geography:'}
          />
        </CustomControl>

        <Select
          id={'manual_geo_select'}
          placeholder={
            <FormattedMessage
              id={'flow.features.news_showcase.settings.geo.placeholder'}
              defaultMessage={'Choose the country'}
            />
          }
          options={geoList}
          isClearable={false}
          onChange={e => change(e, '4')}
          disabled={!isManualGeo}
          value={featuresList['4']}
          className="features-control features-control--select"
        />
      </li>

      <li>
        <CustomControl
          key={`manual_theme_control`}
          id={`manual_theme_control`}
          name={`manual_theme_control`}
          checked={isManualTheme}
          value={1}
          onChange={handleChange.bind(null, 'theme')}
          type="checkbox"
          className="custom-control-xs"
        >
          <FormattedMessage
            id={'flow.features.news_showcase.settings.theme.label'}
            defaultMessage={'News theme:'}
          />
        </CustomControl>

        <Select
          id={'manual_geo_select'}
          placeholder={
            <FormattedMessage
              id={'flow.features.news_showcase.settings.theme.placeholder'}
              defaultMessage={'Choose the theme'}
            />
          }
          options={themesList}
          isClearable={false}
          onChange={e => change(e, '3')}
          disabled={!isManualTheme}
          value={featuresList['3']}
          className="features-control features-control--select"
        />
      </li>
    </ul>
  );
};

export default NewsShowcaseSettings;
